import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { area, line, curveMonotoneX } from 'd3-shape';
import { scaleLinear } from 'd3-scale';
import { max } from 'd3-array';
var curveFunction = curveMonotoneX;
var defaultColors = {
  area: 'rgba(199, 228, 255, 0.5)',
  line: '#004585'
};

var Sparkline = /*#__PURE__*/function (_PureComponent) {
  _inherits(Sparkline, _PureComponent);

  function Sparkline() {
    _classCallCheck(this, Sparkline);

    return _possibleConstructorReturn(this, _getPrototypeOf(Sparkline).apply(this, arguments));
  }

  _createClass(Sparkline, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          lines = _this$props.lines,
          width = _this$props.width,
          height = _this$props.height;
      var maxX = max(lines, function (s) {
        return s.values.length - 1;
      });
      var maxY = max(lines, function (s) {
        return max(s.values);
      });
      var x = scaleLinear().domain([0, maxX]).range([0, width]); // Set range to 1 to make room for the line stroke

      var y = scaleLinear().domain([0, maxY]).range([height, 1]);
      var areaFunction = area().x(function (d, i) {
        return x(i);
      }).y0(height).y1(function (d) {
        return y(d);
      }).curve(curveFunction);
      var lineFunction = line().x(function (d, i) {
        return x(i);
      }).y(function (d) {
        return y(d);
      }).curve(curveFunction);
      return React.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height)
      }, lines.map(function (line, index) {
        var colors = _objectSpread({}, defaultColors, line.colors);

        return React.createElement("g", {
          key: line.key || index
        }, React.createElement("path", {
          d: areaFunction(line.values),
          fill: colors.area
        }, line.title && React.createElement("title", null, line.title)), React.createElement("path", {
          d: lineFunction(line.values),
          stroke: colors.line,
          fill: "none"
        }));
      }));
    }
  }]);

  return Sparkline;
}(PureComponent);

_defineProperty(Sparkline, "displayName", 'Sparkline');

_defineProperty(Sparkline, "propTypes", {
  lines: PropTypes.arrayOf(PropTypes.shape({
    values: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
    colors: PropTypes.shape({
      area: PropTypes.string.isRequired,
      line: PropTypes.string.isRequired
    }),
    title: PropTypes.string,
    key: PropTypes.any
  })).isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
});

export { Sparkline as default };